import { GetLeaderboardRankingsQuery, LeaderboardType } from "@/graphql/types";
import { getCurrencyFormatter } from "@/utils/currencies";

export function displayEntryScore(
  entry: GetLeaderboardRankingsQuery["leaderboardRankings"][0] | undefined | null
) {
  if (entry?.leaderboard === LeaderboardType.NftPrice) {
    return getCurrencyFormatter().format(entry.currencyScore.amount ?? 0);
  } else return entry?.score ?? 0;
}
